import { mapState } from 'vuex'

export default {
    methods: {
        async showAlert (text = 'error!!!', type = 'error', timeout = 2000) {
            await this.$store.dispatch('A_SET_ALERT', { text, type, timeout })
        }
    },
    computed: {
        ...mapState(['alert']),
        getAlertText () {
            return this.alert.alertText
        },
        getAlertType () {
            return this.alert.alertType
        },
        getShowAlert () {
            return this.alert.isShowAlert
        }
    }
}
